import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Section from '../Section';
import s from './ListContainer.css';

class ListContainer extends React.Component {
  render (){
    return (
      <div className={s.Alert_container}>
        <Section container>
          <Section>
            <div className={s.Alerts}>
              {this.props.children}
            </div>
          </Section>
        </Section>
      </div>
    )
  }
}

export default withStyles(s)(ListContainer);



// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/ListContainer.js